//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CardSeparator from '../../../../components/Card/CardSeparator.vue'

export default {
  components: {
    CardSeparator
  },
  props: {
    dataFormControl: {
      type: Object,
      default: null
    },
    workAreas: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      accessControl: false,
      accessWorkArea: [],
      item: null,
      loading: true,
      propsConfig: {},
      optionsParentAccess: [
        { value: 'notUpdate', icon: 'mdi-selection', text: 'Не менять доступ у родительских каталогов' },
        { value: 'copy', icon: 'mdi-content-copy', text: 'Заменить доступы для всех родительских каталогов' },
        { value: 'duplicate', icon: 'mdi-content-duplicate', text: 'Добавить доступы для всех родительских каталогов' }
      ]
    }
  },
  watch: {
    'dataFormControl.calcTime': function (data) {
      if (data) {
        this.loadInfo()
      }
    }
  },
  created: function () {
    this.loadInfo()
  },
  methods: {
    loadInfo: function () {
      const accessControl = !!((this.dataFormControl.accessControl && this.dataFormControl.accessControl.access == null))
      const accessData = (this.dataFormControl.accessControl && this.dataFormControl.accessControl.access) ? this.dataFormControl.accessControl.access : []
      const _node = this.dataFormControl.item
      if (accessControl) {
        this.$set(_node, 'access', this.workAreas.map(item => item.key))
      } else {
        this.$set(_node, 'access', accessData)
      }
      this.$set(_node, 'accessControl', accessControl)
      const _oldAccess = {}
      this.propsConfig = { node: _node, fullAccess: accessControl, oldAccess: _oldAccess }
      if (_node.parent) {
        this.$set(this.propsConfig, 'parentAccess', 'duplicate')
        this.$set(_oldAccess, 'parentAccess', 'duplicate')
      }
      if (_node.children && _node.children.length > 0) {
        this.$set(this.propsConfig, 'childrenAccess', true)
        this.$set(_oldAccess, 'childrenAccess', true)
      }
      this.$set(_oldAccess, 'fullAccess', accessControl)
      this.$set(_oldAccess, 'access', _node.access)
      this.loading = false
    },
    toogleAccess: function (value, type = 'group') {
      let amountChange = 0
      const props = {}
      if (type == 'group') {
        this.$set(this.propsConfig, 'fullAccess', value.length == this.workAreas.length)
        if (value.length > 0) {
          this.$set(this.propsConfig.node, 'access', JSON.parse(JSON.stringify(value.sort((previous, next) => previous > next ? 1 : -1))))
        }
      } else if (type == 'full' && value) {
        this.$set(this.propsConfig.node, 'access', this.workAreas.map(item => item.key))
      } else if (type == 'full' && !value) {
        this.$set(this.propsConfig.node, 'access', [])
      }
      Object.keys(this.propsConfig).forEach(key => {
        if (key !== 'node') {
          this.$set(props, key, this.propsConfig[key])
          if (key !== 'oldAccess') {
            amountChange += this.propsConfig[key] !== this.propsConfig.oldAccess[key] ? 1 : 0
          }
        } else {
          this.$set(props, 'access', this.propsConfig.node.access)
          amountChange += JSON.stringify(this.propsConfig.node.access) !== JSON.stringify(this.propsConfig.oldAccess.access) ? 1 : 0
        }
      })
      this.$emit('change-access', { amount: amountChange, props: props })
    },
    onRestart: function () {
      Object.keys(this.propsConfig.oldAccess).forEach(key => {
        if (key !== 'access') {
          this.$set(this.propsConfig, key, this.propsConfig.oldAccess[key])
        } else {
          this.$set(this.propsConfig.node, 'access', this.propsConfig.oldAccess[key])
        }
      })
      this.$emit('change-access', { amount: 0, props: this.propsConfig })
    }
  }
}
